export function getClientWindowSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  }
}